export default __webpack_public_path__ + "static/startup-award-0527546529fbcc804ef8d876e0f0d1d1.svg";